<div class="container-fluid">
    <!-- 
    <div class="row">
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isRequired]="true" [isFloatingLabel]="true" iconName="keyboard_arrow_down" [isSelect]="true"
                inputId="BMUs">
                <select njFormField id="BMUs" [(ngModel)]="Instruction.units">
                    <option *ngFor="let unit of BMUList" value='{{unit}}'>{{unit}}</option>
                </select>
                <ng-container njFormLabel>Unit</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
-->
    <div class="row">
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EventStartTime" [isRequired]="true">
                <input type="date" id="EventStartTime" njFormField [(ngModel)]="Instruction.issuedFrom"
                    (ngModelChange)="onStartDateChanged($event)" />
                <ng-container njFormLabel>Issued From</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EventEndTime" [isDisabled]="true">
                <input type="date" id="EventEndTime" njFormField [(ngModel)]="Instruction.issuedTo" />
                <ng-container njFormLabel>Issued To</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-6">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="dateComments" [isRequired]="false">
                <input type="text" id="dateComments" njFormField [(ngModel)]="Instruction.dateComment" />
                <ng-container njFormLabel>Date Comments</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">&nbsp;</div>
    <div class="row title">
        1- Water Commitment
    </div>
    <div class="row">

        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [isFloatingLabel]="false"
                inputId="waterCommitment">
                <textarea njFormField id="waterCommitment" [disabled]="false" rows="5"
                    [(ngModel)]="Instruction.instructionData.waterCommitment"></textarea>

                <ng-container njFormSubscript>{{Instruction.instructionData.waterCommitment}}</ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">&nbsp;</div>
    <div class="row title">
        <div>
            2- Indicative max contract book commitment (generation) split by EFA block
        </div>
        <div class="col-md-12">
            <div class="text-right" [style]="'margin-bottom: 5px;'">
                <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                    (buttonClick)="AddEFABlockDTO(Instruction.instructionData.maxContractEFABlocks)">
                    Add
                </nj-button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="maxContractEFABlocks" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th class="col-md-1">EFA Block</th>
                        <th class="col-md-6">Max Contract Book Commitment</th>
                        <th class="col-md-1">Action</th>
                    </tr>
                </thead>
                <tbody>
                    @for(EFA of Instruction.instructionData.maxContractEFABlocks; track
                    Instruction.instructionData.maxContractEFABlocks;let i = $index) {
                    <tr>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName="" [inputId]="'efa'+i"
                                [isRequired]="true" size="small">
                                <input type="text" [id]="'efa'+i" njFormField [(ngModel)]="EFA.efa" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td><nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName="" [inputId]="'text'+i"
                                [isRequired]="true" size="small">
                                <input type="text" [id]="'text'+i" njFormField [(ngModel)]="EFA.text" size="small" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                                (buttonClick)="DeleteInstance(Instruction.instructionData.maxContractEFABlocks, i)">
                                Delete
                            </nj-button><br />
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">

        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [isFloatingLabel]="false"
                inputId="maxContractBookCommitmentByEFABlocks">
                <textarea njFormField id="maxContractBookCommitmentByEFABlocks" [disabled]="false" rows="5"
                    [(ngModel)]="Instruction.instructionData.maxContractBookCommitmentByEFABlocks"></textarea>

                <ng-container
                    njFormSubscript>{{Instruction.instructionData.maxContractBookCommitmentByEFABlocks}}</ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">&nbsp;</div>
    <div class="row title">
        3- Trading & BM Spreads
    </div>
    <div class="row">
        · Target spreads for selling additional generation at Ffes units:
    </div>
    <div class="row ">
        <div class="col-md-12 text-right" [style]="'margin-bottom: 5px;'">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="AddSpread(Instruction.instructionData.spreadsFFES)">
                Add
            </nj-button>
        </div>
    </div>
    <div class="row ">
        <div class="col-md-12">
            <table id="spreadsFFES" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th colspan="1">Duty</th>
                        <th colspan="2" class="subDiv">Minimum Target Trading Spread(£/MWh)</th>
                        <th colspan="4" class="subDiv">Minimum Target BM Spreads (£/MWh)</th>
                        <th colspan="1">Action</th>
                    </tr>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th class="rowSubDiv"></th>
                        <th>Into Gen</th>
                        <th class="rowSubDiv">Buy Back Position</th>
                        <th>Offer Into Gen</th>
                        <th>Offer Out of Pump</th>
                        <th>BID Down from Gen</th>
                        <th class="rowSubDiv">BID into Pump</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for(spread of Instruction.instructionData.spreadsFFES; track
                    Instruction.instructionData.spreadsFFES;let i = $index) {
                    <tr>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName="" [inputId]="'FFESDuty'+i"
                                [isRequired]="true" size="small">
                                <input type="text" [id]="'FFESDuty'+i" njFormField [(ngModel)]="spread.duty" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'FFEStrading_IntoGen'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'FFEStrading_IntoGen'+i" njFormField
                                    [(ngModel)]="spread.trading_IntoGen" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'FFEStrading_BuyBackPosition'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'FFEStrading_BuyBackPosition'+i" njFormField
                                    [(ngModel)]="spread.trading_BuyBackPosition" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'FFESbM_OfferIntoGen'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'FFESbM_OfferIntoGen'+i" njFormField
                                    [(ngModel)]="spread.bM_OfferIntoGen" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'FFESbM_OfferOutOfPump'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'FFESbM_OfferOutOfPump'+i" njFormField
                                    [(ngModel)]="spread.bM_OfferOutOfPump" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'FFESbM_BidDownFromGen'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'FFESbM_BidDownFromGen'+i" njFormField
                                    [(ngModel)]="spread.bM_BidDownFromGen" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'FFESbM_BidIntoPump'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'FFESbM_BidIntoPump'+i" njFormField
                                    [(ngModel)]="spread.bM_BidIntoPump" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>

                        <td>
                            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                                (buttonClick)="DeleteInstance(Instruction.instructionData.spreadsFFES, i)">
                                Delete
                            </nj-button><br />
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">
        · Target spreads for selling additional generation at Dino units:
    </div>
    <div class="row">
        <div class="col-md-12 text-right" [style]="'margin-bottom: 5px;'">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="AddSpread(Instruction.instructionData.spreadsDINO)">
                Add
            </nj-button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="spreadsDINO" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th colspan="1">Duty</th>
                        <th colspan="2" class="subDiv">Minimum Target Trading Spread(£/MWh)</th>
                        <th colspan="4" class="subDiv">Minimum Target BM Spreads (£/MWh)</th>
                        <th colspan="1">Action</th>
                    </tr>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th class="rowSubDiv"></th>
                        <th>Into Gen</th>
                        <th class="rowSubDiv">Buy Back Position</th>
                        <th>Offer Into Gen</th>
                        <th>Offer Out of Pump</th>
                        <th>BID Down from Gen</th>
                        <th class="rowSubDiv">BID into Pump</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for(spread of Instruction.instructionData.spreadsDINO; track
                    Instruction.instructionData.spreadsDINO;let i = $index) {
                    <tr>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName="" [inputId]="'DINODuty'+i"
                                [isRequired]="true" size="small">
                                <input type="text" [id]="'DINODuty'+i" njFormField [(ngModel)]="spread.duty" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'DINOtrading_IntoGen'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'DINOtrading_IntoGen'+i" njFormField
                                    [(ngModel)]="spread.trading_IntoGen" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'DINOtrading_BuyBackPosition'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'DINOtrading_BuyBackPosition'+i" njFormField
                                    [(ngModel)]="spread.trading_BuyBackPosition" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'DINObM_OfferIntoGen'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'DINObM_OfferIntoGen'+i" njFormField
                                    [(ngModel)]="spread.bM_OfferIntoGen" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'DINObM_OfferOutOfPump'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'DINObM_OfferOutOfPump'+i" njFormField
                                    [(ngModel)]="spread.bM_OfferOutOfPump" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'DINObM_BidDownFromGen'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'DINObM_BidDownFromGen'+i" njFormField
                                    [(ngModel)]="spread.bM_BidDownFromGen" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'DINObM_BidIntoPump'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'DINObM_BidIntoPump'+i" njFormField
                                    [(ngModel)]="spread.bM_BidIntoPump" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>

                        <td>
                            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                                (buttonClick)="DeleteInstance(Instruction.instructionData.spreadsDINO, i)">
                                Delete
                            </nj-button><br />
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">

        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [isFloatingLabel]="false"
                inputId="spreads">
                <textarea njFormField id="spreads" [disabled]="false" rows="5"
                    [(ngModel)]="Instruction.instructionData.spreads"></textarea>

                <ng-container njFormSubscript>{{Instruction.instructionData.spreads}}</ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">&nbsp;</div>
    <div class="row title">
        4 - Key uncertainties
    </div>
    <div class="row">

        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [isFloatingLabel]="false"
                inputId="keyUncertainties">
                <textarea njFormField id="keyUncertainties" [disabled]="false" rows="5"
                    [(ngModel)]="Instruction.instructionData.keyUncertainties"></textarea>

                <ng-container njFormSubscript>{{Instruction.instructionData.keyUncertainties}}</ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">&nbsp;</div>
    <div class="row title">
        5 - Tendered Ancillary Services
    </div>

    <div class="row">
        Pricing Targets
    </div>
    <div class="row">
        <div class="col-md-12 text-right" [style]="'margin-bottom: 5px;'">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="AddPricingTarget()">
                Add
            </nj-button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="quickReservePricingTarget" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th>Time</th>
                        <th>Station</th>
                        <th>Service</th>
                        <th>Pricing</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    @for(target of Instruction.instructionData.quickReservePricingTarget; track
                    Instruction.instructionData.quickReservePricingTarget; let i = $index){
                    <tr>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName="" [inputId]="'targetTime'+i"
                                [isRequired]="true" size="small">
                                <input type="text" [id]="'targetTime'+i" njFormField [(ngModel)]="target.time" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'targetStation'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'targetStation'+i" njFormField [(ngModel)]="target.station" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'targetService'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'targetService'+i" njFormField [(ngModel)]="target.service" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>

                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'targetPricing'+i" [isRequired]="true" size="small">
                                <input type="number" [id]="'targetPricing'+i" njFormField
                                    [(ngModel)]="target.pricing" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                                (buttonClick)="DeleteInstance(Instruction.instructionData.quickReservePricingTarget, i)">
                                Delete
                            </nj-button><br />
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">
        Standing Limits
    </div>
    <div class="row">
        <div class="col-md-12 text-right" [style]="'margin-bottom: 5px;'">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="AddStandingLimit()">
                Add
            </nj-button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="quickReserveStandingLimits" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th>Service</th>
                        <th>Parameter</th>
                        <th>Station</th>
                        <th>Comment</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    @for(limit of Instruction.instructionData.quickReserveStandingLimits; track
                    Instruction.instructionData.quickReserveStandingLimits; let i = $index){
                    <tr>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'limitService'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'limitService'+i" njFormField [(ngModel)]="limit.service" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'limitParameter'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'limitParameter'+i" njFormField
                                    [(ngModel)]="limit.parameter" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'limitStation'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'limitStation'+i" njFormField [(ngModel)]="limit.station" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>

                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'limitComment'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'limitComment'+i" njFormField [(ngModel)]="limit.comment" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                                (buttonClick)="DeleteInstance(Instruction.instructionData.quickReserveStandingLimits, i)">
                                Delete
                            </nj-button><br />
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [isFloatingLabel]="false"
                inputId="quickReserve">
                <textarea njFormField id="quickReserve" [disabled]="false" rows="5"
                    [(ngModel)]="Instruction.instructionData.quickReserve"></textarea>

                <ng-container njFormSubscript>{{Instruction.instructionData.quickReserve}}</ng-container>
            </nj-form-item>
        </div>
    </div>

    <div class="row">&nbsp;</div>
    <div class="row title">
        6 - Minimum Bid Prices
    </div>

    <div class="row">
        · Mimimum Bid Prices
    </div>
    <div class="row">
        <div class="col-md-12 text-right" [style]="'margin-bottom: 5px;'">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="AddMinimumBidPrice()">
                Add
            </nj-button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="minimumBidPricesTarget" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th>Station</th>
                        <th>Type</th>
                        <th>No technical restrictions (£/MWh)</th>
                        <th>Technical restrictions (£/MWh)</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    @for(minBid of Instruction.instructionData.minimumBidPrices; track
                    Instruction.instructionData.minimumBidPrices; let i = $index){
                    <tr>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isRequired]="true" [isFloatingLabel]="true"
                                iconName="keyboard_arrow_down" [isSelect]="true" [inputId]="'bidStation'+i">
                                <select njFormField [id]="'bidStation'+i" [(ngModel)]="minBid.station">
                                    <option value='dino'>DINO</option>
                                    <option value='ffes'>FFES</option>
                                </select>
                                <ng-container njFormLabel>Station</ng-container>
                                <ng-container njFormSubscript>
                                </ng-container>
                            </nj-form-item>

                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName="" [inputId]="'bidType'+i"
                                [isRequired]="true" size="small">
                                <input type="text" [id]="'bidType'+i" njFormField [(ngModel)]="minBid.type" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                [inputId]="'bidNoTechnRest'+i" [isRequired]="true" size="small">
                                <input type="text" [id]="'bidNoTechnRest'+i" njFormField
                                    [(ngModel)]="minBid.noTechnicalRestrictions" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>

                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName="" [inputId]="'bidTechRest'+i"
                                [isRequired]="true" size="small">
                                <input type="text" [id]="'bidTechRest'+i" njFormField
                                    [(ngModel)]="minBid.technicalRestrictions" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                                (buttonClick)="DeleteInstance(Instruction.instructionData.minimumBidPrices, i)">
                                Delete
                            </nj-button><br />
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">
        · When a First Hydro unit is on a long term outage, please refer to the below table:
    </div>
    <div class="row">&nbsp;</div>
    <div class="row">
        <div class="col-md-4">
            <table id="minOfferAndBidPrices" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th>Type</th>
                        <th>(£/MWh)</th>
                    </tr>
                </thead>
                <tbody>

                    <tr>
                        <td>
                            Offer Price
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                inputId="minimumBidPriceLongOutageOfferPrice" [isRequired]="true" size="small">
                                <input type="number" id="minimumBidPriceLongOutageOfferPrice" njFormField
                                    [(ngModel)]="Instruction.instructionData.minimumBidPriceLongOutageOfferPrice" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Bid Price
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName=""
                                inputId="minimumBidPriceLongOutageBidPrice" [isRequired]="true" size="small">
                                <input type="number" id="minimumBidPriceLongOutageBidPrice" njFormField
                                    [(ngModel)]="Instruction.instructionData.minimumBidPriceLongOutageBidPrice" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">&nbsp;</div>
    <div class="row">
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="SaveInstruction()">
                Save
            </nj-button>
        </div>
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                [style]="'margin-top: 10px;'" (buttonClick)="Cancel()">
                Cancel
            </nj-button>
        </div>
    </div>
</div>